"use strict";
// ---------- General date formatting functions ----------
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateForConversationListEntries = exports.formatMessageTimeStamp = void 0;
const getTimeStringWithHoursAndMinutes = (date) => date.toLocaleTimeString(['de', 'en'], { hour: '2-digit', minute: '2-digit' });
const getGermanDateString = (date) => date.toLocaleDateString('de');
// ---------- Specific use cases ----------
// Mailbox
exports.formatMessageTimeStamp = getTimeStringWithHoursAndMinutes;
exports.formatDateForConversationListEntries = getGermanDateString;
